'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token token from facebook
     * @param {string} params.postal postal code
     * @param {bool} params.optIn opt into wendys mail?
     * * @param {bool} params.terms agree to terms and conditions?
     * @returns {Bluebird Promise}
     */
    createSocialProfile: function createSocialProfile(params, oAuthProvider) {
        return this.postApiRequest(this.getUrl().createProfile + '/' + (oAuthProvider ? oAuthProvider.toLowerCase() : ''), this.pullQueryStringParams(params), params);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/createProfileServiceClient.js
// module id = 838
// module chunks = 0